import { Component } from '@angular/core';

@Component({
    selector: 'app-daily-stat',
    templateUrl: './daily-stat.component.html',
    styleUrls: ['./daily-stat.component.css'],
    standalone: false
})
export class DailyStatComponent {
}
